// The amber strip at the top of a page showing walkthrough data (the sample
// client in the wizard, the sample clients on My Clients). Its one button ends
// the walkthrough and hands the page back to the host, so nobody is left with a
// tour waiting on data that was just taken away.

import type { ReactNode } from 'react';
import { Button } from '@/components/ui/button';
import { useTutorial } from '@/tutorial/TutorialContext';

interface Props {
  /** The anchor the tour points at — written as the attribute so the anchor guard finds it. */
  'data-tour': string;
  children: ReactNode;
  /** Button label. */
  action: string;
  /** What the host does once the walkthrough has ended. */
  onAction: () => void;
}

export default function WalkthroughBanner({ 'data-tour': anchor, children, action, onAction }: Props) {
  const { endWalkthrough } = useTutorial();
  return (
    <div
      data-tour={anchor}
      className="mb-4 flex items-center justify-between gap-3 rounded-lg border border-amber-300 bg-amber-50 px-4 py-2.5 text-sm dark:border-amber-800 dark:bg-amber-950/30"
    >
      <span>{children}</span>
      <Button
        size="sm"
        variant="outline"
        className="shrink-0"
        onClick={() => {
          endWalkthrough();
          onAction();
        }}
      >
        {action}
      </Button>
    </div>
  );
}
